import { render, staticRenderFns } from "./HousingCircle.vue?vue&type=template&id=4bc5ed89&scoped=true"
import script from "./HousingCircle.vue?vue&type=script&lang=js"
export * from "./HousingCircle.vue?vue&type=script&lang=js"
import style0 from "./HousingCircle.vue?vue&type=style&index=0&id=4bc5ed89&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc5ed89",
  null
  
)

export default component.exports